import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, SearchIcon, FilterIcon, ChevronDownIcon, CheckCircleIcon, AlertCircleIcon, ClockIcon, BarChart2Icon, PieChartIcon, UsersIcon, CalendarIcon, RefreshCwIcon, SlidersIcon, DownloadIcon, XCircleIcon, FileTextIcon, InfoIcon, EyeIcon, PlusIcon } from 'lucide-react';
export function ClaimsReportsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('active');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  // Mock data for metrics
  const metrics = {
    totalClaims: 152,
    pendingClaims: 37,
    approvedClaims: 98,
    rejectedClaims: 17,
    avgResponseTime: '3.2 days',
    warrantyRate: '64%'
  };
  // Mock data for claims
  const claimsData = [{
    id: '202534704',
    date: 'Jul 7, 2025',
    dealer: 'AGRO+ SRL',
    reportedBy: 'GIULIA OGNIBENE',
    responsible: 'Régis SIMIER',
    type: 'Warranty',
    status: 'Approved',
    isNew: false
  }, {
    id: '202528724',
    date: 'Jun 30, 2025',
    dealer: 'ZEPPELIN',
    reportedBy: 'Grishin Dmitriy',
    responsible: 'Cristina Guillot',
    type: 'Missing part',
    status: 'Requested',
    isNew: true
  }, {
    id: '202523188',
    date: 'Jun 27, 2025',
    dealer: 'YUGAGROPOLIV LLC',
    reportedBy: 'Evgeny Radchenko',
    responsible: 'Evgeny Radchenko',
    type: 'Warranty',
    status: 'Approved',
    isNew: false
  }, {
    id: '202528723',
    date: 'Jun 26, 2025',
    dealer: 'ZEPPELIN',
    reportedBy: 'Grishin Dmitriy',
    responsible: 'Cristina Guillot',
    type: 'Technical issue',
    status: 'Approved',
    isNew: false
  }, {
    id: '202528722',
    date: 'Jun 26, 2025',
    dealer: 'ZEPPELIN',
    reportedBy: 'Grishin Dmitriy',
    responsible: 'Cristina Guillot',
    type: 'Technical issue',
    status: 'Approved',
    isNew: false
  }, {
    id: '202559',
    date: 'Jun 24, 2025',
    dealer: '',
    reportedBy: 'Daniel Fernández',
    responsible: 'Murad Elafsheh',
    type: 'Technical issue by region',
    status: 'Requested',
    isNew: true
  }, {
    id: '202558',
    date: 'Jun 24, 2025',
    dealer: '',
    reportedBy: 'Daniel Fernández',
    responsible: 'Murad Elafsheh',
    type: 'Technical issue by region',
    status: 'Requested',
    isNew: true
  }];
  // Filter claims based on active tab
  const filteredClaims = claimsData.filter(claim => {
    if (activeTab === 'active') {
      return claim.status === 'Requested' || claim.status === 'In Progress';
    } else {
      return claim.status === 'Approved' || claim.status === 'Rejected';
    }
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-7895" data-mp="1entey6b7m3nt">
      {/* Header */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 text-white" data-id="element-7896" data-mp="1jl3cyacnznn9">
        <div className="container mx-auto px-6 py-6" data-id="element-7897" data-mp="39015z8keu0eb">
          <div className="flex justify-between items-center" data-id="element-7898" data-mp="3dz4dcznv4ipg">
            <div className="flex items-center" data-id="element-7899" data-mp="3dwi50xt5dz66">
              <button onClick={() => navigate('/support')} className="mr-3 p-2 hover:bg-blue-900/50 rounded-full transition-colors" data-id="element-7900" data-mp="3o1q7wdm5s5on">
                <ArrowLeftIcon size={20} data-id="element-7901" data-mp="3j59ilg383l9z" />
              </button>
              <h1 className="text-2xl font-bold" data-id="element-7902" data-mp="pp3ooh7nank">Claims Reports</h1>
            </div>
            <div className="flex gap-3" data-id="element-7903" data-mp="3s3l6hacpg4yq">
              <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors flex items-center shadow-sm" data-id="element-7904" data-mp="3s2jvt6zlpkhj">
                <PlusIcon size={18} className="mr-2" data-id="element-7905" data-mp="apfyysdlhtop" />
                Report New Claim
              </button>
              <button className="px-4 py-2 bg-blue-800/30 hover:bg-blue-800/50 rounded-lg transition-colors flex items-center border border-blue-700/30" data-id="element-7906" data-mp="jo1gck7bz2nw">
                <DownloadIcon size={18} className="mr-2" data-id="element-7907" data-mp="fn7rnom2djty" />
                Export
              </button>
            </div>
          </div>
          {/* Tabs */}
          <div className="flex mt-6 border-b border-blue-800/50" data-id="element-7908" data-mp="2hektg4sqjbls">
            <button className={`px-5 py-3 ${activeTab === 'active' ? 'border-b-2 border-white font-medium' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('active')} data-id="element-7909" data-mp="2hgfjtymrzvx9">
              Active Claims
            </button>
            <button className={`px-5 py-3 ${activeTab === 'closed' ? 'border-b-2 border-white font-medium' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('closed')} data-id="element-7910" data-mp="2rvene2e1zhsj">
              Closed Claims
            </button>
          </div>
        </div>
      </div>
      {/* Metrics Panels */}
      <div className="container mx-auto px-6 py-6" data-id="element-7911" data-mp="245kf7y4oihem">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6" data-id="element-7912" data-mp="2449de3usnjq5">
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7913" data-mp="294naiquux99e">
            <div className="flex items-center justify-between mb-3" data-id="element-7914" data-mp="2dx6woc7m1cpt">
              <h3 className="text-gray-500 font-medium" data-id="element-7915" data-mp="1gh147au8vqiu">Claims Overview</h3>
              <BarChart2Icon className="text-blue-600" size={20} data-id="element-7916" data-mp="1gex3t2vk19nb" />
            </div>
            <div className="grid grid-cols-3 gap-2" data-id="element-7917" data-mp="1le1fc05ybjgt">
              <div className="text-center" data-id="element-7918" data-mp="1dwlangohzux4">
                <div className="text-3xl font-bold text-blue-600" data-id="element-7919" data-mp="1dvjwh3c6qsb6">
                  {metrics.totalClaims}
                </div>
                <div className="text-sm text-gray-500" data-id="element-7920" data-mp="13y5m9lguuzrb">Total</div>
              </div>
              <div className="text-center" data-id="element-7921" data-mp="140076zs4mrve">
                <div className="text-3xl font-bold text-amber-500" data-id="element-7922" data-mp="zvimmydy0ajk">
                  {metrics.pendingClaims}
                </div>
                <div className="text-sm text-gray-500" data-id="element-7923" data-mp="uys7cd9ypiz7">Pending</div>
              </div>
              <div className="text-center" data-id="element-7924" data-mp="q5657f1fcxhn">
                <div className="text-3xl font-bold text-green-500" data-id="element-7925" data-mp="l7nv3lbo8c82">
                  {metrics.approvedClaims}
                </div>
                <div className="text-sm text-gray-500" data-id="element-7926" data-mp="g9mb8y6f88vj">Approved</div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7927" data-mp="c6g8i0iioztt">
            <div className="flex items-center justify-between mb-3" data-id="element-7928" data-mp="78xzka4i2klt">
              <h3 className="text-gray-500 font-medium" data-id="element-7929" data-mp="3tp5b7464x9hg">Claim Types</h3>
              <PieChartIcon className="text-indigo-600" size={20} data-id="element-7930" data-mp="3ts19wupt426y" />
            </div>
            <div className="flex items-center justify-center h-16" data-id="element-7931" data-mp="1n724l14m4vd">
              <div className="flex items-center gap-4" data-id="element-7932" data-mp="3jsiosay5uadb">
                <div className="flex flex-col items-center" data-id="element-7933" data-mp="3oqkbr6ypitu2">
                  <div className="flex items-center" data-id="element-7934" data-mp="3oqu1ctfuayz8">
                    <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-7935" data-mp="ga8q15zqjtsy"></div>
                    <span className="text-sm text-gray-600" data-id="element-7936" data-mp="l9va9zdzeab9">Warranty</span>
                  </div>
                  <span className="font-bold" data-id="element-7937" data-mp="6kyv7idibx15">{metrics.warrantyRate}</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-7938" data-mp="bk20n3xeg59n">
                  <div className="flex items-center" data-id="element-7939" data-mp="bih7niqqgudw">
                    <div className="w-3 h-3 rounded-full bg-amber-500 mr-1" data-id="element-7940" data-mp="z94iabs19y45"></div>
                    <span className="text-sm text-gray-600" data-id="element-7941" data-mp="140crp7td5jhb">Technical</span>
                  </div>
                  <span className="font-bold" data-id="element-7942" data-mp="2oqrwvdigu3k1">24%</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-7943" data-mp="2ooni20j13k4z">
                  <div className="flex items-center" data-id="element-7944" data-mp="2jqm41u0gmb0d">
                    <div className="w-3 h-3 rounded-full bg-green-500 mr-1" data-id="element-7945" data-mp="2xj27ux16qd2c"></div>
                    <span className="text-sm text-gray-600" data-id="element-7946" data-mp="2xl6894zvktxv">Missing</span>
                  </div>
                  <span className="font-bold" data-id="element-7947" data-mp="2tjl0tz6417v2">12%</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7948" data-mp="20t2o06fl3s4g">
            <div className="flex items-center justify-between mb-3" data-id="element-7949" data-mp="2eskj13jh41m9">
              <h3 className="text-gray-500 font-medium" data-id="element-7950" data-mp="2etvmt3cx59dd">Response Time</h3>
              <ClockIcon className="text-amber-600" size={20} data-id="element-7951" data-mp="29sfy91bj8kq8" />
            </div>
            <div className="flex flex-col items-center justify-center h-16" data-id="element-7952" data-mp="3q77rfggi5w0l">
              <div className="text-3xl font-bold text-amber-600" data-id="element-7953" data-mp="3l8o6njdnaq9t">
                {metrics.avgResponseTime}
              </div>
              <div className="text-sm text-gray-500" data-id="element-7954" data-mp="9662ulu7vlhh">Average response time</div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7955" data-mp="e5iv5m3uxkrg">
            <div className="flex items-center justify-between mb-3" data-id="element-7956" data-mp="i5t14yrngb6b">
              <h3 className="text-gray-500 font-medium" data-id="element-7957" data-mp="mwrm4bnl1xfw">Status Distribution</h3>
              <PieChartIcon className="text-green-600" size={20} data-id="element-7958" data-mp="myvwncfzlup5" />
            </div>
            <div className="space-y-3" data-id="element-7959" data-mp="rvmf26f9l2dq">
              <div data-id="element-7960" data-mp="wupar09ctw91">
                <div className="flex justify-between text-sm mb-1" data-id="element-7961" data-mp="wu61s91omi75">
                  <span className="text-gray-600" data-id="element-7962" data-mp="11u25062k25ln">Approved</span>
                  <span className="font-medium text-gray-800" data-id="element-7963" data-mp="11utq2myj0kxo">
                    {metrics.approvedClaims}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-7964" data-mp="33lx65rr6qrpm">
                  <div className="bg-green-500 h-2 rounded-full" style={{
                  width: `${metrics.approvedClaims / metrics.totalClaims * 100}%`
                }} data-id="element-7965" data-mp="37n0ii4a0y5m3"></div>
                </div>
              </div>
              <div data-id="element-7966" data-mp="2vc985mzhw6c2">
                <div className="flex justify-between text-sm mb-1" data-id="element-7967" data-mp="2vbpz6vrtosa6">
                  <span className="text-gray-600" data-id="element-7968" data-mp="2qdepcl1j2hry">Pending</span>
                  <span className="font-medium text-gray-800" data-id="element-7969" data-mp="2qdy11k0l49xj">
                    {metrics.pendingClaims}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-7970" data-mp="3j2lnvk0zf7d7">
                  <div className="bg-amber-500 h-2 rounded-full" style={{
                  width: `${metrics.pendingClaims / metrics.totalClaims * 100}%`
                }} data-id="element-7971" data-mp="3e391f0e0w2b5"></div>
                </div>
              </div>
              <div data-id="element-7972" data-mp="3533v6tkkf9yk">
                <div className="flex justify-between text-sm mb-1" data-id="element-7973" data-mp="351j2l9hta13c">
                  <span className="text-gray-600" data-id="element-7974" data-mp="1ym8izmv7rnu8">Rejected</span>
                  <span className="font-medium text-gray-800" data-id="element-7975" data-mp="1ykff2fbzjhpx">
                    {metrics.rejectedClaims}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-7976" data-mp="1rkqlqw2e2lib">
                  <div className="bg-red-500 h-2 rounded-full" style={{
                  width: `${metrics.rejectedClaims / metrics.totalClaims * 100}%`
                }} data-id="element-7977" data-mp="1mmp5sk09f2b2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Search and Filters */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6 overflow-hidden" data-id="element-7978" data-mp="2abrlhmbc2l2x">
          <div className="p-5 border-b border-gray-100" data-id="element-7979" data-mp="25d6v0elvvfro">
            <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-7980" data-mp="25corqy0t01a9">
              <div className="relative flex-1 min-w-[300px]" data-id="element-7981" data-mp="2jbepmfvg64zo">
                <input type="text" placeholder="Search by code, reported by or responsible" className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-7982" data-mp="2fbe1g3ijqfff" />
                <SearchIcon className="absolute left-3 top-3 text-gray-400" size={18} data-id="element-7983" data-mp="at4z8g1q9em7" />
              </div>
              <div className="flex items-center gap-3" data-id="element-7984" data-mp="eui70vodrrvr">
                <button className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center" onClick={() => setShowFilters(!showFilters)} data-id="element-7985" data-mp="eu8bkskkgsio">
                  <SlidersIcon size={18} className="mr-2" data-id="element-7986" data-mp="6153z0wlr9vy" />
                  Filters
                  <ChevronDownIcon size={16} className="ml-1" data-id="element-7987" data-mp="3n9id9zkjnvpx" />
                </button>
                <button className="px-3 py-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors flex items-center" data-id="element-7988" data-mp="3s9wmvm1sndq2">
                  <RefreshCwIcon size={16} className="mr-1" data-id="element-7989" data-mp="3ebg8d8xowixd" />
                  Reset
                </button>
              </div>
            </div>
            {/* Expanded filters */}
            {showFilters && <div className="mt-4 pt-4 border-t border-gray-100 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-7990" data-mp="1cj1t6hmj5skn">
                <div className="relative" data-id="element-7991" data-mp="1hgtqjr5y26w8">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7992" data-mp="1f3g64645c474">
                    Status
                  </label>
                  <select className="appearance-none w-full bg-gray-50 px-4 pr-8 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7993" data-mp="1b0a111srsj28">
                    <option data-id="element-7994" data-mp="113yrgjkke7bh">All statuses</option>
                    <option data-id="element-7995" data-mp="1159uuia3ld22">Requested</option>
                    <option data-id="element-7996" data-mp="1yr74dq6i281v">In Progress</option>
                    <option data-id="element-7997" data-mp="1yt0cl9wrh0bz">Approved</option>
                    <option data-id="element-7998" data-mp="1trb33yp6suq0">Rejected</option>
                  </select>
                  <ChevronDownIcon className="absolute right-3 bottom-3 text-gray-500" size={16} data-id="element-7999" data-mp="1p14ehyuoda7r" />
                </div>
                <div className="relative" data-id="element-8000" data-mp="1k2jdhx7lmmi9">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-8001" data-mp="1k1hyxirdjhvs">
                    Dealer
                  </label>
                  <select className="appearance-none w-full bg-gray-50 px-4 pr-8 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-8002" data-mp="2hj8c7i1958nf">
                    <option data-id="element-8003" data-mp="2k3xyh7jfhpij">All dealers</option>
                    <option data-id="element-8004" data-mp="2p04tw6e77im8">AGRO+ SRL</option>
                    <option data-id="element-8005" data-mp="2p16htbgbbzld">ZEPPELIN</option>
                    <option data-id="element-8006" data-mp="2tzht7qm9ai5p">YUGAGROPOLIV LLC</option>
                  </select>
                  <ChevronDownIcon className="absolute right-3 bottom-3 text-gray-500" size={16} data-id="element-8007" data-mp="2yz443tem3mbc" />
                </div>
                <div className="relative" data-id="element-8008" data-mp="3318y4t8z2kyi">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-8009" data-mp="330644cgcs2ed">
                    Claim Type
                  </label>
                  <select className="appearance-none w-full bg-gray-50 px-4 pr-8 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-8010" data-mp="37xfvhxnayo4u">
                    <option data-id="element-8011" data-mp="3hrom2fsrw70d">All claim types</option>
                    <option data-id="element-8012" data-mp="3mpq1mqqzpo73">Warranty</option>
                    <option data-id="element-8013" data-mp="3mmlrzdura091">Technical issue</option>
                    <option data-id="element-8014" data-mp="3qrblwx5ut4rb">Missing part</option>
                    <option data-id="element-8015" data-mp="3qnxidllgepia">Technical issue by region</option>
                  </select>
                  <ChevronDownIcon className="absolute right-3 bottom-3 text-gray-500" size={16} data-id="element-8016" data-mp="s7xqykz5uxb7" />
                </div>
                <div className="relative" data-id="element-8017" data-mp="1122rjw43jn3x">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-8018" data-mp="11114et9t3a5u">
                    Date Range
                  </label>
                  <input type="date" className="appearance-none w-full bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-8019" data-mp="x1afyw7r564h" />
                </div>
                <div className="relative" data-id="element-8020" data-mp="4e67gh9ga9ny">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-8021" data-mp="ibuqrknvd8qw">
                    Responsible
                  </label>
                  <input type="text" placeholder="Filter by responsible person" className="appearance-none w-full bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-8022" data-mp="dayg8o90ioci" />
                </div>
                <div className="relative" data-id="element-8023" data-mp="1x85sxxphk9ge">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-8024" data-mp="1x7dwkko2e7p2">
                    Reported By
                  </label>
                  <input type="text" placeholder="Filter by reporter" className="appearance-none w-full bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-8025" data-mp="1nahm49elvbhv" />
                </div>
              </div>}
          </div>
          {/* Active filters */}
          <div className="px-5 py-3 bg-gray-50 flex flex-wrap items-center gap-2" data-id="element-8026" data-mp="2ky050d1zdtzl">
            <span className="text-sm text-gray-500 mr-2" data-id="element-8027" data-mp="269dfxjmjxnv6">Active filters:</span>
            <span className="bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full flex items-center" data-id="element-8028" data-mp="2679ed8c4l0y2">
              Status: Requested
              <XCircleIcon size={14} className="ml-1 cursor-pointer" data-id="element-8029" data-mp="2yxj1g8lfjgw2" />
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full flex items-center" data-id="element-8030" data-mp="33ohjpdpzap1y">
              Dealer: ZEPPELIN
              <XCircleIcon size={14} className="ml-1 cursor-pointer" data-id="element-8031" data-mp="3djf0fr7bg0sr" />
            </span>
          </div>
        </div>
        {/* Claims Table */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6" data-id="element-8032" data-mp="38jtxl5p0z8ar">
          <div className="overflow-x-auto" data-id="element-8033" data-mp="2zkyui2ha2ebo">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-8034" data-mp="2zjx8j2yq47f6">
              <thead className="bg-gray-50" data-id="element-8035" data-mp="2ullyos8fhwwy">
                <tr data-id="element-8036" data-mp="2ungj85fsfn0i">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8037" data-mp="2unyotsocbdl3">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8038" data-mp="2kwu9usynzsq9">
                    Claim
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8039" data-mp="2bv4hnkwykprf">
                    Dealer
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8040" data-mp="26ye3x48mm696">
                    Reported by
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8041" data-mp="rc0pslsy204y">
                    Responsible
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8042" data-mp="10ejr31h304p3">
                    Claim type
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8043" data-mp="3locevexjb6z">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-8044" data-mp="cmme371wb6me">
                {filteredClaims.map(claim => <tr key={claim.id} className="hover:bg-gray-50 transition-colors" data-id="element-8045" data-mp="hh0h9vmsui1m">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-8046" data-mp="3g33bnc8h7v65">
                      <div className="flex items-center" data-id="element-8047" data-mp="3l2y1dcgimepm">
                        {claim.status === 'Approved' ? <CheckCircleIcon size={16} className="text-green-500 mr-2" data-id="element-8048" data-mp="2ehzox83og61o" /> : claim.status === 'Requested' ? <ClockIcon size={16} className="text-amber-500 mr-2" data-id="element-8049" data-mp="29in5yyfxfj4d" /> : <AlertCircleIcon size={16} className="text-red-500 mr-2" data-id="element-8050" data-mp="29k6m8p1l1u65" />}
                        <span className={`px-2 py-1 text-xs rounded-full ${claim.status === 'Approved' ? 'bg-green-100 text-green-800' : claim.status === 'Rejected' ? 'bg-red-100 text-red-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-8051" data-mp="2nixsxqe48dk9">
                          {claim.status}
                        </span>
                      </div>
                      {claim.isNew && <span className="ml-6 mt-1 inline-block px-2 py-0.5 text-xs bg-blue-500 text-white rounded-full" data-id="element-8052" data-mp="3763vdvu2on5f">
                          New
                        </span>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-8053" data-mp="3g5immxi2d1qz">
                      <div className="text-sm font-medium text-gray-900" data-id="element-8054" data-mp="3g3xufej81uwa">
                        {claim.id}
                      </div>
                      <div className="text-xs text-gray-500 flex items-center" data-id="element-8055" data-mp="3usppsh1b4vfb">
                        <CalendarIcon size={12} className="mr-1" data-id="element-8056" data-mp="3mfz48tu4ies" />
                        {claim.date}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-8057" data-mp="3ls1brmbwyv2f">
                      {claim.dealer ? <div className="text-sm text-gray-900" data-id="element-8058" data-mp="3psl4mdpgfcir">
                          {claim.dealer}
                        </div> : <span className="text-xs text-gray-500" data-id="element-8059" data-mp="3c16msa7a9hda">—</span>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-8060" data-mp="3gusox8ftm2uu">
                      {claim.reportedBy}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-8061" data-mp="372vcxzgzn6v2">
                      {claim.responsible}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-8062" data-mp="2t4f5g6baxcbv">
                      <div className="flex items-center" data-id="element-8063" data-mp="2y1os5e7b39w0">
                        <span className={`px-2 py-1 text-xs rounded-full ${claim.type === 'Warranty' ? 'bg-blue-100 text-blue-800' : claim.type === 'Missing part' ? 'bg-purple-100 text-purple-800' : 'bg-indigo-100 text-indigo-800'}`} data-id="element-8064" data-mp="2w9tjepw4a1gz">
                          {claim.type}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-8065" data-mp="2s8rup2ztt7t9">
                      <div className="flex items-center justify-end space-x-2" data-id="element-8066" data-mp="3fz428cr5t2jb">
                        <button className="p-1.5 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors" data-id="element-8067" data-mp="3jycs36j2wg9l">
                          <EyeIcon size={16} data-id="element-8068" data-mp="367hqmfawt1g1" />
                        </button>
                        <button className="p-1.5 bg-gray-50 text-gray-600 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8069" data-mp="3b62hvp86oasc">
                          <FileTextIcon size={16} data-id="element-8070" data-mp="2pzkqdep64i9" />
                        </button>
                        <button className="p-1.5 bg-gray-50 text-gray-600 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8071" data-mp="7isoaxyfj6sr">
                          <InfoIcon size={16} data-id="element-8072" data-mp="guq48cshxzxr" />
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          {filteredClaims.length === 0 && <div className="text-center py-12" data-id="element-8073" data-mp="ln145fn8llqb">
              <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-8074" data-mp="lob5cdpdza16">
                <FileTextIcon size={24} className="text-gray-400" data-id="element-8075" data-mp="3u5ffw0nd2ew5" />
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-1" data-id="element-8076" data-mp="3q3kc8phyjpf7">
                No claims found
              </h3>
              <p className="text-gray-500" data-id="element-8077" data-mp="7ts07ui25sf6">
                Try adjusting your filters or search criteria
              </p>
            </div>}
        </div>
        {/* Pagination */}
        <div className="flex items-center justify-between" data-id="element-8078" data-mp="1j9gnyo34yvh1">
          <div className="text-sm text-gray-600" data-id="element-8079" data-mp="1ed00lw3rgl50">
            Showing <span className="font-medium" data-id="element-8080" data-mp="1eekvjmtzm63e">1</span> to{' '}
            <span className="font-medium" data-id="element-8081" data-mp="1mc4oobm49m0x">{filteredClaims.length}</span> of{' '}
            <span className="font-medium" data-id="element-8082" data-mp="1qdq3i2i7oadr">{filteredClaims.length}</span> claims
          </div>
          <div className="flex items-center space-x-2" data-id="element-8083" data-mp="1vdb74q8bt6wt">
            <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-8084" data-mp="1vbrpav70unsx">
              Previous
            </button>
            <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-blue-600 text-white font-medium" data-id="element-8085" data-mp="17o01auc4cmbt">
              1
            </button>
            <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-8086" data-mp="1clic6q9p5bmg">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
}